module.exports = __webpack_public_path__ + "assets/img/gd2.c2f90380.jpg";